/*
 * Product grid cards (+ ADD over the image).
 *
 * SA Variants (Combined Listings) swaps a card over to a sibling product
 * when a swatch is clicked: it changes the image, title, link and price.
 * The "+ ADD" button was rendered for the original product, so before it
 * acts we check which product the card is showing now (from the title
 * link) and point the button at that product instead.
 */
(function () {
  if (window.__pgcCardSync) return;
  window.__pgcCardSync = true;

  function productPath(href) {
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/[^/?#]+/);
      return match ? match[0] : null;
    } catch (e) {
      return null;
    }
  }

  function currentPath(card) {
    var link = card.querySelector('.card__heading a[href]');
    return link ? productPath(link.getAttribute('href')) : null;
  }

  function fetchProduct(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root.replace(/\/$/, '') + path + '.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('Product fetch failed');
      return r.json();
    });
  }

  function needsOptions(data) {
    return !data || !data.variants || data.variants.length !== 1;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.pgc__add');
      if (!button) return;
      var card = button.closest('.pgc');
      if (!card) return;

      var original = productPath(card.getAttribute('data-product-url'));
      var shown = currentPath(card);
      if (!shown) return;

      if (shown === original) {
        // Swatch switched back to the original product: undo any swap.
        var originalInput = card.querySelector('form input[name="id"][data-original-id]');
        if (originalInput) originalInput.value = originalInput.getAttribute('data-original-id');
        button.removeAttribute('data-pgc-synced');
        if (button.tagName === 'A') button.setAttribute('href', original);
        if (button.hasAttribute('data-product-url')) button.setAttribute('data-product-url', original);
        return;
      }

      // Link style button: just follow the product now shown.
      if (button.tagName === 'A') {
        button.setAttribute('href', shown);
        return;
      }

      // Quick picker button: load the product now shown in the pop-up.
      if (button.hasAttribute('data-product-url')) {
        button.setAttribute('data-product-url', shown);
        return;
      }

      // Direct add to cart: swap in the shown product's variant first.
      var form = button.closest('form');
      if (!form) return;
      if (button.getAttribute('data-pgc-synced') === shown) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.setAttribute('aria-disabled', 'true');

      fetchProduct(shown)
        .then(function (data) {
          if (needsOptions(data)) {
            window.location.href = shown;
            return;
          }
          var variant = data.variants[0];
          if (!variant.available) {
            window.location.href = shown;
            return;
          }
          var input = form.querySelector('input[name="id"]');
          if (input) {
            input.value = variant.id;
            input.disabled = false;
          }
          button.setAttribute('data-pgc-synced', shown);
          button.removeAttribute('aria-disabled');
          if (form.requestSubmit) {
            form.requestSubmit(button);
          } else {
            button.click();
          }
        })
        .catch(function () {
          window.location.href = shown;
        });
    },
    true
  );
})();
